window.axios = require('axios');

import ContactForm from './components/ContactForm';

// import { VueReCaptcha } from 'vue-recaptcha-v3'

// Vue.use(VueReCaptcha, {
//     siteKey: '6LcLuZYUAAAAAFxWtdNufs_yLU7znMSDxJFJaVPs',
//     loaderOptions: {
//         useRecaptchaNet: true
//     }
// });

import { initializeMap } from './map.js';

function initialize() {
    const root = document.getElementById('app')

    if (window.vue) {
        window.vue.$destroy(true)
    }

    window.Vue = require('vue');
    Vue.config.productionTip = false;

    new Vue({
        components: {
            ContactForm,
        },
    }).$mount('#app');

    initializeMap();
}

if (process.env.NODE_ENV === 'production') {
    document.addEventListener('turbolinks:load', (event) => {
        initialize();
    });
} else {
    initialize();
}


